<template>
  <!-- Pre-program content -->
  <main role="main" class="container">
    <div class="text-center py-md-5 px-md-4 py-3">
      <h1 class="text-center mb-3" v-html="$t('PostProgram.ProgramEndedTitle')"></h1>
      <p v-html="$t('PostProgram.ProgramEndedDesc')"></p>
      <p v-html="$t('PostProgram.AlertCTABtn')" class="my-4 text-center"></p>
    </div>
  </main>
</template>
<script>
export default {
  props: {
    endDate: {
      type: Date,
      required: true,
    },
  },
};
</script>
